import React, { useState, useEffect, useCallback } from 'react';
import { Container, Card, Button, Row, Col, Form, Tabs, Tab } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useHistory, useParams } from 'react-router-dom';
import Header from '~/Components/Header/Header';
import Loading from '~/Components/Loading';
import * as api from '~/Services/Service';
import TabParticipantes from './Tabs/TabParticipantes';
import TabContasAutorizadas from './Tabs/TabContasAutorizadas';
import TabEmpreendimentos from './Tabs/TabEmpreendimentos';
import TabUsuarios from './Tabs/TabUsuarios';
import TabRelatorios from './Tabs/TabRelatorios';
import TabListaNegra from './Tabs/TabListaNegra';

const EdicaoParceria = () => {
  const history = useHistory();
  const params = useParams();
  const codigo = parseInt(params.codigo, 10);

  const [detalhes, setDetalhes] = useState(null);
  const [loading, setLoading] = useState(true);
  const [tabAtiva, setTabAtiva] = useState('participantes');
  const [descricao, setDescricao] = useState('');
  const [salvandoHeader, setSalvandoHeader] = useState(false);

  const carregarDetalhes = useCallback(() => {
    setLoading(true);
    api.obterDetalhesParceria(codigo)
      .then((resp) => {
        setDetalhes(resp);
        setDescricao(resp.descricao || '');
      })
      .catch((err) => {
        toast.error((err && err.message) || 'Erro ao carregar parceria');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [codigo]);

  useEffect(() => {
    carregarDetalhes();
  }, [carregarDetalhes]);

  const recarregar = useCallback(() => {
    return api.obterDetalhesParceria(codigo)
      .then((resp) => {
        setDetalhes(resp);
        setDescricao(resp.descricao || '');
      })
      .catch((err) => {
        toast.error((err && err.message) || 'Erro ao recarregar parceria');
      });
  }, [codigo]);

  const salvarHeaderEFlags = async (novosFlags) => {
    if (!detalhes) return;
    setSalvandoHeader(true);
    const payload = {
      codigo_parceria: detalhes.codigo_parceria,
      descricao: descricao.trim(),
      rel_espelho_vendas: novosFlags ? novosFlags.rel_espelho_vendas : detalhes.rel_espelho_vendas,
      rel_fluxo_caixa: novosFlags ? novosFlags.rel_fluxo_caixa : detalhes.rel_fluxo_caixa,
      rel_dem_rec_desp_sintetico: novosFlags ? novosFlags.rel_dem_rec_desp_sintetico : detalhes.rel_dem_rec_desp_sintetico,
      rel_dem_rec_desp_analitico: novosFlags ? novosFlags.rel_dem_rec_desp_analitico : detalhes.rel_dem_rec_desp_analitico,
      taxa_adm: novosFlags ? novosFlags.taxa_adm : detalhes.taxa_adm,
      lotes_vendidos: novosFlags ? novosFlags.lotes_vendidos : detalhes.lotes_vendidos,
      lotes_rescindidos: novosFlags ? novosFlags.lotes_rescindidos : detalhes.lotes_rescindidos,
      pos_total_carteira: novosFlags ? novosFlags.pos_total_carteira : detalhes.pos_total_carteira,
      resumo_inad: novosFlags ? novosFlags.resumo_inad : detalhes.resumo_inad,
      acomp_receb: novosFlags ? novosFlags.acomp_receb : detalhes.acomp_receb,
      contratos_quitados: novosFlags ? novosFlags.contratos_quitados : detalhes.contratos_quitados,
      contratos_abertos: novosFlags ? novosFlags.contratos_abertos : detalhes.contratos_abertos,
      mapa_inadimplencia: novosFlags ? novosFlags.mapa_inadimplencia : detalhes.mapa_inadimplencia,
      financ_habitacional: novosFlags ? novosFlags.financ_habitacional : detalhes.financ_habitacional,
      saldo_distribuir_comissao: novosFlags ? novosFlags.saldo_distribuir_comissao : detalhes.saldo_distribuir_comissao,
      inad_acomp_rec_todos: novosFlags ? novosFlags.inad_acomp_rec_todos : detalhes.inad_acomp_rec_todos,
    };
    try {
      if (!payload.descricao) {
        toast.error('Descrição é obrigatória');
        return;
      }
      if (payload.descricao.length > 40) {
        toast.error('Descrição deve ter no máximo 40 caracteres');
        return;
      }
      await api.atualizarParceria(payload);
      toast.success('Parceria salva com sucesso');
      recarregar();
    } catch (err) {
      toast.error((err && err.message) || 'Erro ao salvar parceria');
    } finally {
      setSalvandoHeader(false);
    }
  };

  if (loading) return <Loading />;
  if (!detalhes) return <p className="text-center text-muted mt-4">Parceria não encontrada.</p>;

  return (
    <Container fluid className="px-3 py-3">
      <Header title={'Parceria #' + codigo + ' — ' + detalhes.descricao} />

      <Button
        variant="link"
        className="px-0 mb-2"
        onClick={() => history.push('/cadastros/parcerias')}
      >
        ← Voltar
      </Button>

      <Card className="shadow-sm mb-3">
        <Card.Header className="py-2" style={{ backgroundColor: '#0747a6', color: '#fff' }}>
          <strong>Identificação</strong>
        </Card.Header>
        <Card.Body className="py-3">
          <Row className="align-items-end">
            <Col md={2}>
              <Form.Group className="mb-0">
                <Form.Label className="font-weight-bold mb-1">Código</Form.Label>
                <Form.Control type="text" value={detalhes.codigo_parceria} readOnly disabled style={{ backgroundColor: '#f5f5f5' }} />
              </Form.Group>
            </Col>
            <Col md={7}>
              <Form.Group className="mb-0">
                <Form.Label className="font-weight-bold mb-1">
                  Descrição <span className="text-danger">*</span>
                </Form.Label>
                <Form.Control
                  type="text"
                  value={descricao}
                  onChange={(e) => setDescricao(e.target.value)}
                  maxLength={40}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Button
                variant="success"
                onClick={() => salvarHeaderEFlags(null)}
                disabled={salvandoHeader}
                block
              >
                {salvandoHeader ? 'Salvando...' : 'Salvar'}
              </Button>
            </Col>
          </Row>
        </Card.Body>
      </Card>

      <Card className="shadow-sm">
        <Card.Body className="p-0">
          <Tabs
            activeKey={tabAtiva}
            onSelect={(k) => setTabAtiva(k)}
            className="px-3 pt-2"
          >
            <Tab eventKey="participantes" title="Participantes">
              <div className="p-3">
                <TabParticipantes parceria={detalhes} onAlterado={recarregar} />
              </div>
            </Tab>
            <Tab eventKey="contas" title="Contas Autorizadas">
              <div className="p-3">
                <TabContasAutorizadas parceria={detalhes} onAlterado={recarregar} />
              </div>
            </Tab>
            <Tab eventKey="empreendimentos" title="Empreendimentos">
              <div className="p-3">
                <TabEmpreendimentos parceria={detalhes} onAlterado={recarregar} />
              </div>
            </Tab>
            <Tab eventKey="usuarios" title="Usuários">
              <div className="p-3">
                <TabUsuarios parceria={detalhes} onAlterado={recarregar} />
              </div>
            </Tab>
            <Tab eventKey="relatorios" title="Relatórios">
              <div className="p-3">
                <TabRelatorios parceria={detalhes} onSalvar={salvarHeaderEFlags} />
              </div>
            </Tab>
            <Tab eventKey="lista-negra" title="Lista Negra">
              <div className="p-3">
                <TabListaNegra parceria={detalhes} onAlterado={recarregar} />
              </div>
            </Tab>
          </Tabs>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default EdicaoParceria;
